module.exports = __webpack_public_path__ + "static/media/tela-cheia.cb271cbf.svg";